import { BlockClicks } from "lib/@components/block-clicks.js"
import { useBoundContext } from "lib/@components/binding/use-bound-context.js"
import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item.js"
import { useDialog } from "lib/@hooks/useDialog.js"
import { getOriginatingSchedule } from "routes/schedule/plugins/custom-schedule-from-tailored/lib/get-originating-schedule.js"
import { errorSnackbar } from "lib/snackbar/error-snackbar.js"
import { getTreeId } from "library/id-helpers.mjs"
import { OpenDraft } from "event-definitions"
import { NewScheduleDialog } from "routes/schedule/my-schedules/my-custom-schedules/new-schedule-dialog.js"
import { createTailoredCopy } from "routes/schedule/plugins/custom-schedule-from-tailored/controller/create-tailored-copy.controller.js"
import { normalizeNodeId } from "routes/schedule/plugins/custom-schedule-from-tailored/lib/normalize-node-id.js"

export function CreateTailoredCopyMenuItem() {
    const { schedule } = useBoundContext()
    const setupSchedule = useDialog(<NewScheduleDialog />, { maxWidth: "sm", fullScreen: false })
    const treeId = getTreeId(schedule?.id)

    return (
        <BlockClicks>
            <ContextMenuItem
                icon="carbon:document-export"
                label="Derive Copy From Tailoring"
                onClick={createCopy}
                data-cy="create-tailored-copy-menu-item"
            />
        </BlockClicks>
    )

    async function createCopy() {
        // the bound schedule is a tree node, not a schedule object, so have to retrieve originating schedule information
        // if it exists, which is a request -> wrap in busyWhile
        const source = await getOriginatingSchedule(schedule?.id)
        const definition = await setupSchedule(source)
        if (!definition) return

        try {
            const draftId = await createTailoredCopy({
                definition,
                scheduleNodeId: normalizeNodeId(schedule),
                treeId,
            })
            OpenDraft(draftId).raise(draftId)
        } catch (error) {
            errorSnackbar("Could not create a custom copy of this tailored schedule")
        }
    }
}
